const balanceDueReducer = (state = '', action) => {
	switch(action.type){
	case 'BALANCEEXISTS':
		return 'Remaining Balance: ';
	default:
		return state;
	}
}

export default balanceDueReducer;